export enum DashboardIPOsOnMoveWidgetFilterField {
  Type = 'type',
}
